/*
 * @Author: liym35984
 * @Date: 2021-11-08 18:09:27
 * @LastEditors: liym35984
 * @LastEditTime: 2021-11-23 10:09:09
 * @FilePath: \openplat-web\src\gtn\api\submitWorkOrderApi\submitWorkOrder.js
 */
import fetch from "@/api/httpFetch.js";
const modelName = "/openplat-developer-server/v/";
/***获取相关产品列表***/
export function myList() {
  return fetch.post("/openplat-service-server/v/myservice/mylist");
}
/***提交工单***/
export function addFeedback() {
  return fetch.get(modelName + "userFeedback/addFeedback");
}
// 获取服务信息下拉列表框
export function getServiceComboxList(data) {
  return fetch.post("/openplat-service-server/v/service/queryServiceComboxList", data);
}
// 获取服务信息下拉列表框
export function queryFeedBackServiceComboxList(data) {
  return fetch.post("/openplat-service-server/v/service/queryFeedBackServiceComboxList", data);
}
// 获取快捷选择产品列表
export function queryTopServiceInfoList(data) {
  return fetch.post("/openplat-service-server/v/service/queryTopServiceInfoList", data);
}
//提交申述工单
export function submitWorkOrder() {
  return fetch.get(modelName + "feedback/submitWorkOrder");
}



// WEBPACK FOOTER //
// ./src/gtn/api/submitWorkOrderApi/submitWorkOrder.js